exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* @value black, kardia-green, kardia-orange from '../../../styles/variables/colors.css'; */\n\n.DbCQIoZ9J9Bn0fQFTIEPH {\n  height: 100%;\n  position: relative;\n}\n\n._2V0bDhyprnhmktJEqp_0m {\n  margin-left: calc((1140px / 2) - 155px);\n}\n\n.Y8I9zChQCkHZodKa5n4Td {\n  margin-left: calc((1090px / 2) - 155px);\n}\n\n._308ameLRGnB2xgUccql3Hf {\n  stroke: #1c2a43;\n  margin-right: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"teamInvitesTable": "DbCQIoZ9J9Bn0fQFTIEPH",
	"emailPopover": "_2V0bDhyprnhmktJEqp_0m",
	"emailPopoverWithSelection": "Y8I9zChQCkHZodKa5n4Td",
	"cancelIcon": "_308ameLRGnB2xgUccql3Hf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Tables/TeamInvitesTable/TeamInvitesTable.css
// module id = 9034
// module chunks = 23